const modifiers = {
  snakeCase: (str) => str.split(' ').join('_'),
}

export default modifiers
